<!--
 * @Author: cmchiu
 * @Date: 2022-04-26 09:45:38
 * @LastEditTime: 2022-07-28 18:51:56
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\Notice\notice.vue
 * 
-->
<template>
    <div class="notice"
         v-if="showModal">
        <div :class="`modal ${ showModal ? 'show' : '' }`"
             tabindex="-1"
             aria-labelledby="..."
             aria-hidden="true"
             id="warning_Modal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                @click="hideModal"></button>
                    </div>
                    <div class="modal-body">
                        <img :src="`${baseUrl}assets/images/notice.png`"
                             alt="">
                        <h4 class="modal-title">緊急公告</h4>
                        <div class="pl-15 pr-15">
                            <p>{{ notice !== null ? notice.TitleC : '' }}</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"
                                class="btn"
                                data-bs-dismiss="modal"
                                @click="hideModal">確認</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUrgentNotice } from '@/api/campus'

export default {
    name: 'notice',

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            notice: null,
            showModal: false,
        }
    },

    created: function () {
        this.getUrgentNotice()
    },

    methods: {
        async getUrgentNotice() {
            const vm = this
            let params = {
                blockID: '1000310006000041',
            }
            await getUrgentNotice(params).then(res => {
                if (res.Code === 1 && res.TotalResult > 0) {
                    vm.notice = res.Items[0]
                    vm.showModal = true
                } else {
                    vm.showModal = false
                }
            })
        },

        hideModal() {
            this.showModal = false
        },
    },
}
</script>

<style scoped></style>